import module from 'fan/proyecto/module.js'

export const FanProyectoConfiguracionPuestosSchema = {
  id_puesto: 'number',
  eliminable: 'boolean',
}

export class FanProyectoConfiguracionPuestosService {
  constructor($http) {
    this.$http = $http
  }

  get(idProyecto) {
    return this.$http.get('/api2/proyecto/configuracion/puestos', {
      params: {id_proyecto: idProyecto},
      schema: FanProyectoConfiguracionPuestosSchema,
    })
  }

  post(idProyecto, data) {
    return this.$http.post('/api2/proyecto/configuracion/puestos', data, {
      params: {id_proyecto: idProyecto},
      schema: FanProyectoConfiguracionPuestosSchema,
    })
  }
}

module.service('FanProyectoConfiguracionPuestosService', FanProyectoConfiguracionPuestosService)



// WEBPACK FOOTER //
// ./src/fan/proyecto/services/Proyecto/Configuracion/Puestos.js